module.exports = __webpack_public_path__ + "img/fa-solid-900.376c1f97.svg";